export default "__VITE_ASSET__BCPODn5a__"